import { __assign } from "tslib";
import { normalizeProvider } from "@aws-sdk/util-middleware";
import { getEndpointFromRegion } from "./utils/getEndpointFromRegion";
export var resolveEndpointsConfig = function (input) {
    var _a;
    var useDualstackEndpoint = normalizeProvider(input.useDualstackEndpoint);
    var endpoint = input.endpoint, useFipsEndpoint = input.useFipsEndpoint, urlParser = input.urlParser;
    return __assign(__assign({}, input), { tls: (_a = input.tls) !== null && _a !== void 0 ? _a : true, endpoint: endpoint
            ? normalizeProvider(typeof endpoint === "string" ? urlParser(endpoint) : endpoint)
            : function () { return getEndpointFromRegion(__assign(__assign({}, input), { useDualstackEndpoint: useDualstackEndpoint, useFipsEndpoint: useFipsEndpoint })); }, isCustomEndpoint: !!endpoint, useDualstackEndpoint: useDualstackEndpoint });
};
